import axios from 'axios'

const pings = {
  set (page, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/ping',
      { 'username': localStorage.getItem('username'),
        'page': page,
      },
      {'headers': 
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleRequest(promise, cb)
  },

  get (page, cb) {
    const promise = axios.get('https://api.psyco.fr/cafe/ping',
      {
        params: { 
          username: localStorage.getItem('username'),
          page: page,
        },
        headers: {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleResults(promise, cb)
  },

  handleResults(promise, cb) {
    promise.then((resp) => {
      if (resp.data.code && resp.data.code !== 200) {
        cb([])
      }
      else {
        cb(resp.data.data)
      }
    }).catch((error) => cb([]))
  },

  handleRequest (promise, cb) {
    promise.then((resp) => {
      cb(true)
    }).catch((error) => cb(false))
  },
}

export default pings
